// ================================================================
// Deposit review reason → Thai label
// แปลรหัส reviewReason ที่ wallet/sms/slip ส่งให้แอดมิน/ผู้ใช้
// ใช้ใน TransactionPage และทุกที่ที่แสดง "หมายเหตุ" ของรายการฝาก
// ================================================================

const DEPOSIT_REVIEW_REASON_LABELS: Record<string, string> = {
    // ── SMS side ───────────────────────────────────────────────
    amount_not_detected: 'ระบบหายอดเงินจากข้อความ SMS ไม่เจอ',
    categorized_as_deposit: 'จัดข้อความเข้าหมวด "ฝาก" แล้ว',
    categorized_as_withdrawal: 'จัดข้อความเข้าหมวด "ถอน" แล้ว',
    categorized_as_other: 'ข้อความถูกจัดเป็นหมวดอื่นที่ไม่ใช่การฝาก',
    categorized_as_unknown: 'ระบบยังจัดหมวดข้อความไม่ได้',
    source_account_suffix_not_detected: 'หาเลขท้ายบัญชีต้นทางจากข้อความไม่เจอ',
    duplicate_semantic_sms: 'พบข้อความ SMS ซ้ำกับรายการก่อนหน้า',
    profile_disabled: 'โปรไฟล์ SMS นี้ถูกปิดใช้งาน',
    raw_sms_pending_admin_action: 'รอแอดมินตรวจสอบข้อความ SMS ที่ระบบยังจับคู่ไม่ได้',
    ambiguous_user_bank_suffix: 'เลขบัญชีของผู้ใช้ตรงกันมากกว่า 1 รายการ ต้องให้แอดมินตรวจ',
    user_bank_suffix_not_found: 'ไม่พบบัญชีของผู้ใช้ที่ตรงกับเลขท้ายบนข้อความ',
    sms_auto_credit_disabled: 'ตั้งค่าปิดการเติมเครดิตอัตโนมัติจาก SMS ไว้',
    sms_manual_review_required: 'ระบบ SMS ระบุให้รอแอดมินตรวจสอบ',

    // ── Slip side ──────────────────────────────────────────────
    slip_not_verified: 'SlipOK ไม่ได้ยืนยันสลิป (อาจเป็นสลิปปลอม/ภาพไม่ชัด)',
    slip_amount_missing: 'ไม่พบยอดเงินบนสลิป',
    slip_amount_mismatch: 'ยอดบนสลิปไม่ตรงกับยอดที่ผู้ใช้แจ้ง',
    user_info_not_found: 'ไม่พบข้อมูลผู้ใช้สำหรับตรวจสอบสลิป',
    user_account_inactive: 'บัญชีผู้ใช้ถูกระงับหรือเป็นบัญชีระบบ',
    user_high_risk_group: 'ผู้ใช้อยู่ในกลุ่มที่ถูกบล็อกทั้งบัญชี (ไม่อนุญาตให้เติมอัตโนมัติ)',
    user_bank_account_missing: 'ผู้ใช้ยังไม่มีบัญชีธนาคารที่ใช้งานได้ในระบบ',
    slip_receiver_mismatch: 'บัญชีปลายทางบนสลิปไม่ตรงกับบัญชีรับฝากของเว็บ',
    slip_sender_account_mismatch: 'ธนาคาร/เลขบัญชีต้นทางไม่ตรงกับบัญชีของผู้ใช้',
    slip_sender_account_ambiguous: 'พบบัญชีต้นทางตรงกันมากกว่า 1 รายการ',
    slip_sender_name_mismatch: 'ชื่อผู้โอนบนสลิปไม่ตรงกับชื่อในบัญชีของผู้ใช้',
    slip_sender_name_uncertain: 'ชื่อผู้โอนตรงเพียงบางส่วน ระบบยังไม่มั่นใจ รอแอดมินตรวจสอบ',
    slip_auto_credit_disabled: 'ตั้งค่าปิดการเติมเครดิตอัตโนมัติจากสลิปไว้',
    slip_verification_failed: 'การตรวจสอบสลิปกับ SlipOK ไม่สำเร็จ รอแอดมินตรวจสอบอีกครั้ง',
    slip_guard_failed: 'ข้อมูลผู้โอน/ผู้รับไม่ตรงเงื่อนไขเติมเครดิตอัตโนมัติ',
    slip_guard_failed_admin: 'แอดมินตรวจซ้ำแล้วยังไม่ผ่านเงื่อนไขเติมอัตโนมัติ',
    late_slip_verified_manual_review: 'แนบสลิปทีหลัง รอแอดมินตรวจสอบ',
    late_slip_verification_failed: 'แนบสลิปทีหลังแต่ตรวจสลิปไม่ผ่าน รอแอดมินตรวจสอบ',
    admin_slip_verification_failed: 'แอดมินตรวจสลิปแล้วไม่ผ่าน',
    missing_slip_or_sms_fallback: 'ยังไม่ได้แนบสลิป รอข้อความ SMS หรือให้แอดมินตรวจสอบ',

    // ── Manual / system ─────────────────────────────────────────
    manual_slip_review: 'ผู้ใช้แนบสลิปแล้ว รอแอดมินตรวจสอบ',
    manual_payment_review: 'รายการฝากจาก Payment Gateway รอแอดมินตรวจสอบ',
    sms_only_manual_review: 'โหมด SMS-only กำลังรอจับคู่ข้อความหรือให้แอดมินตรวจสอบ',
    cancelled_by_admin: 'รายการถูกยกเลิกโดยแอดมิน',
    cash_deposit_without_source_account: 'ฝากเงินสดที่ไม่ระบุบัญชีต้นทาง รอแอดมินตรวจสอบ',

    // ── Status notes (สำหรับ description/note ทั่วไปที่ระบบส่งมา) ──
    'รายการฝากค้าง รอแนบสลิป': 'รายการฝากค้าง รอแนบสลิป',
    'รายการฝากเงิน': 'รายการฝากเงิน',
    'รายการถอนเงิน': 'รายการถอนเงิน',
}

const STALE_SMS_PATTERN = /^stale_sms_over_(\d+)m$/i
const CATEGORIZED_PATTERN = /^categorized_as_([a-z_]+)$/i

const matchCompoundReason = (token: string): string | null => {
    const trimmed = token.trim()
    if (!trimmed) return null

    const staleMatch = trimmed.match(STALE_SMS_PATTERN)
    if (staleMatch) {
        const minutes = staleMatch[1]
        return minutes ? `ข้อความ SMS เก่าเกิน ${minutes} นาที` : 'ข้อความ SMS เก่าเกินกำหนด'
    }

    const categorizedMatch = trimmed.match(CATEGORIZED_PATTERN)
    if (categorizedMatch && !DEPOSIT_REVIEW_REASON_LABELS[trimmed]) {
        const category = categorizedMatch[1]
        return `จัดข้อความเข้าหมวด "${category}"`
    }

    return null
}

/**
 * แปล reviewReason / note ใดๆ ให้กลายเป็นข้อความไทยที่ผู้ใช้ทั่วไปเข้าใจได้
 * - รับ string ใดๆ (โค้ดเดียวกัน หรือคั่นด้วย "," ก็ได้)
 * - ถ้าไม่มีในตารางจะคืนค่าเดิม (ป้องกันการซ่อนข้อมูลสำคัญ)
 * - ถ้าค่าว่างจะคืน fallback ที่ส่งมา หรือ "-"
 */
export const translateDepositReviewReason = (
    value?: string | null,
    fallback: string = '-'
): string => {
    const raw = String(value || '').trim()
    if (!raw) return fallback

    if (DEPOSIT_REVIEW_REASON_LABELS[raw]) {
        return DEPOSIT_REVIEW_REASON_LABELS[raw]
    }

    const compound = matchCompoundReason(raw)
    if (compound) return compound

    if (raw.includes(',')) {
        return raw
            .split(',')
            .map((part) => {
                const key = part.trim()
                if (!key) return ''
                if (DEPOSIT_REVIEW_REASON_LABELS[key]) return DEPOSIT_REVIEW_REASON_LABELS[key]
                return matchCompoundReason(key) || key
            })
            .filter(Boolean)
            .join(' • ')
    }

    return raw
}

export default translateDepositReviewReason
